<template>
  <div class="showentries mb-3">
    <label
      >Show
      <select @change="handlePageSizeChange" :value="defaultPageSize || 50">
        <!-- <option value="1">1</option>

                <option value="5">5</option> -->

        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <!-- <option value="500">500</option>
                <option value="1000">1000</option> -->
        <!-- <option v-if="allowedAll" value="all">All</option> -->
        <!-- <option v-if="true" value="10000">All</option> -->
      </select>
      entries
    </label>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  emits: ["page-size-changed"],
  props: ["allowedAll", "defaultPageSize"],
  methods: {
    ...mapActions({
      updatePageSize: "theme/updatePageSize",
      updatePagination: "theme/updatePagination",
    }),
    handlePageSizeChange(ev) {
      this.$emit("page-size-changed", ev.target.value);
      // console.log("ev", ev.target.value)
      // if (Number(ev.target.value)) {
      //     this.updatePageSize(Number(ev.target.value))
      // }
    },
  },
  mounted() {
    this.$emit("page-size-changed", this.defaultPageSize || 10);
  },
  unmounted() {
    this.updatePagination({
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0,
    });
  },

  // handleTableChange(pagination) {

  //   this.pagination = {
  //     ...pagination,
  //     current: pagination.current,
  //     pageSize: pagination.pageSize,
  //   };
  // },
};
</script>

<style lang="scss" scoped></style>
